__turbopack_context__.v({
  "blocksBackgroundColor": "MobileNav-module-scss-module__fKfPVW__blocksBackgroundColor",
  "blocksFontColor": "MobileNav-module-scss-module__fKfPVW__blocksFontColor",
  "exitContainer": "MobileNav-module-scss-module__fKfPVW__exitContainer",
  "hasVisibleChild": "MobileNav-module-scss-module__fKfPVW__hasVisibleChild",
  "link": "MobileNav-module-scss-module__fKfPVW__link",
  "menuContainer": "MobileNav-module-scss-module__fKfPVW__menuContainer",
  "menuItem": "MobileNav-module-scss-module__fKfPVW__menuItem",
  "metisMenuIcon": "MobileNav-module-scss-module__fKfPVW__metisMenuIcon",
  "mobileClose": "MobileNav-module-scss-module__fKfPVW__mobileClose",
  "mobileMenuContainer": "MobileNav-module-scss-module__fKfPVW__mobileMenuContainer",
  "navContainer": "MobileNav-module-scss-module__fKfPVW__navContainer",
  "search": "MobileNav-module-scss-module__fKfPVW__search",
  "secondaryNavBackgroundColor": "MobileNav-module-scss-module__fKfPVW__secondaryNavBackgroundColor",
  "shortcutList": "MobileNav-module-scss-module__fKfPVW__shortcutList",
  "shortcutListFourItems": "MobileNav-module-scss-module__fKfPVW__shortcutListFourItems",
  "themeBackgroundColor": "MobileNav-module-scss-module__fKfPVW__themeBackgroundColor",
  "themeFontColor": "MobileNav-module-scss-module__fKfPVW__themeFontColor",
  "themeFontFamily": "MobileNav-module-scss-module__fKfPVW__themeFontFamily",
  "transitionEnter": "MobileNav-module-scss-module__fKfPVW__transitionEnter",
  "transitionEnterActive": "MobileNav-module-scss-module__fKfPVW__transitionEnterActive",
  "transitionEnterDone": "MobileNav-module-scss-module__fKfPVW__transitionEnterDone",
  "transitionExit": "MobileNav-module-scss-module__fKfPVW__transitionExit",
  "transitionExitActive": "MobileNav-module-scss-module__fKfPVW__transitionExitActive",
  "transitionExitDone": "MobileNav-module-scss-module__fKfPVW__transitionExitDone",
});
